<template>
  <aside class="error-wrapper" role="alert">
    <mark class="error-item">
      <font-awesome-icon icon="exclamation-triangle" class="error-item_icon" />
      <p
        class="error-item__description"
        v-if="error"
        v-t="error"
      ></p>
      <p class="error-item__description" v-else>
        <slot></slot>
      </p>
    </mark>
  </aside>
</template>

<script>

export default {
  name: "error",
  props: {
    error: {
      type: String,
      required: false
    }
  }
};
</script>